/* Angebot im Shop (Roadmap 3.48 Paket G-T, Konzept docs/konzept_service_im_shop.md in mhsys; Vorbild service/b2b/angebot/).
 * Geladen aus layout/theme.liquid nur auf /pages/angebot (template.suffix "angebot").
 *
 * Endpunkte (Enna, Paket G), alle POST mit JSON an /apps/kunde?bereich=angebot&teil=…:
 *   code      { code }                                   -> { ok, token }
 *   ansicht   { token }                                  -> { ok, nummer, datum, gueltig, positionen:[{anzahl,name,hinweis,summe}],
 *                                                            zwischensumme?, rabatt?:{prozent,betrag}, versand?:{titel,betrag}, gesamt,
 *                                                            rechte:{zusage,nachricht,grund}, adressen:{rechnung:[], liefer:[]|null} }
 *   annehmen  { token, schluessel, website, _stempel }   -> { ok, meldung }
 *   nachricht { token, text, vorgang, dateien:[kennungen], website, _stempel } -> { ok, meldung }   (Text ODER Datei)
 *   datei     multipart token, vorgang, datei           -> { ok, kennung, name, groesse }
 *   datei_weg { token, vorgang, kennung }                -> { ok }
 *   Fehler { ok:false, fehler, meldung, felder? }
 *
 * Token (ange_token) nur in sessionStorage "mhsysAngebot" und im Rumpf, nie in einer Adresse; der Einmal-Code kommt als
 * #c=… und wird im Kopf der Seite vor jedem Pixel aus der Adresse genommen (window.mhsysBsCode). Werte per textContent.
 * Dateien: dateien bleibt leer, bis der Upload-Weg aus Paket 0 steht (dann nur hochladen() ergaenzen).
 */
(function () {
  "use strict";
  var wurzel = document.querySelector("[data-mhsys-angebot]");
  if (!wurzel || wurzel.getAttribute("data-ag-bereit")) return;
  wurzel.setAttribute("data-ag-bereit", "1");

  var SCHLUESSEL = "mhsysAngebot";
  /* Zeitstempel statt _dauer (Roadmap 7.59): window.mhsysStempel aus mhsys-kopf.js haengt _stempel an, warm geholt beim Oeffnen */
  function stempeln(r) { return window.mhsysStempel ? window.mhsysStempel.mit(r) : Promise.resolve(r); }
  if (window.mhsysStempel) window.mhsysStempel.vor();
  var OHNE_ZUGANG = "Bitte öffne dein Angebot über den Link in unserer E-Mail.";
  var annehmenSchluessel = "";

  function text(v) { return v === null || v === undefined ? "" : String(v); }
  function el(tag, klasse, inhalt) {
    var e = document.createElement(tag);
    if (klasse) e.className = klasse;
    if (inhalt) e.textContent = inhalt;
    return e;
  }
  function lesen() { try { return sessionStorage.getItem(SCHLUESSEL) || ""; } catch (e) { return ""; } }
  function merken(t) { try { t ? sessionStorage.setItem(SCHLUESSEL, t) : sessionStorage.removeItem(SCHLUESSEL); } catch (e) {} }
  // Mit Zeitlimit (layout/theme.liquid, Roadmap 7.44): antwortet mhsys nicht, kommt der Fehler-Zustand statt ewigem Laden
  function holen(url, init) { return window.mhsysNetz ? window.mhsysNetz.holen(url, init) : fetch(url, init); }
  function senden(teil, daten) {
    return holen("/apps/kunde?bereich=angebot&teil=" + teil, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(daten || {}),
      credentials: "same-origin",
      cache: "no-store",
    }).then(function (r) {
      return r.json().catch(function () { return { ok: false, fehler: "antwort" }; }).then(function (j) {
        return j && typeof j === "object" ? j : { ok: false, fehler: "antwort" };
      });
    });
  }
  function zustand(name) {
    wurzel.querySelectorAll("[data-ag-zustand]").forEach(function (z) { z.hidden = z.getAttribute("data-ag-zustand") !== name; });
  }
  function hinweis(satz) {
    wurzel.querySelector("[data-ag-hinweis]").textContent = satz;
    zustand("hinweis");
  }
  function meldung(wo, satz) {
    var m = wurzel.querySelector('[data-ag-meldung="' + wo + '"]');
    m.textContent = satz || "";
    m.hidden = !satz;
  }
  function erfolg(satz) {
    var e = wurzel.querySelector("[data-ag-erfolg]");
    e.textContent = satz || "";
    e.hidden = !satz;
    if (satz) e.scrollIntoView({ block: "center" });
  }
  function schluessel() {
    var b = new Uint8Array(16);
    window.crypto.getRandomValues(b);
    return Array.prototype.map.call(b, function (x) { return ("0" + x.toString(16)).slice(-2); }).join("");
  }

  /* ---- Ansicht ---- */
  function zeile(links, rechts, klasse) {
    var p = el("p", "mhsys-ag__summe" + (klasse ? " " + klasse : ""));
    p.appendChild(el("span", "", links));
    p.appendChild(el("span", "", rechts));
    return p;
  }
  function zeichnen(a) {
    wurzel.querySelector("[data-ag-titel]").textContent = a.nummer ? "Angebot " + text(a.nummer) : "Dein Angebot";
    var unter = wurzel.querySelector("[data-ag-unter]");
    unter.textContent = a.datum ? "vom " + text(a.datum) : "";
    unter.hidden = !a.datum;

    var ul = wurzel.querySelector("[data-ag-posten]");
    ul.textContent = "";
    (Array.isArray(a.positionen) ? a.positionen : []).forEach(function (p) {
      var li = el("li", "mhsys-ag__position");
      var links = el("span", "mhsys-ag__position-text");
      links.appendChild(el("span", "mhsys-ag__menge", text(p.anzahl) + " ×"));
      links.appendChild(el("span", "mhsys-ag__name", text(p.name)));
      if (p.hinweis) links.appendChild(el("span", "mhsys-ag__hinweis", text(p.hinweis)));
      li.appendChild(links);
      li.appendChild(el("span", "mhsys-ag__preis", text(p.summe)));
      ul.appendChild(li);
    });

    var s = wurzel.querySelector("[data-ag-summen]");
    s.textContent = "";
    /* Netto-Angebot (mhsys, 27.10.2026): Positionen netto, die Summenzeilen kommen fertig aus mhsys (Summe netto, zzgl. MwSt., Gesamt brutto) */
    if (a.preise === "netto" && Array.isArray(a.zeilen) && a.zeilen.length) {
      a.zeilen.forEach(function (z) {
        var art = z.art === "gesamt" ? "mhsys-ag__summe--gesamt" : (z.art === "rabatt" ? "mhsys-ag__summe--rabatt" : "");
        s.appendChild(zeile(text(z.text), text(z.betrag), art));
      });
    } else {
      if (a.rabatt && a.zwischensumme) {
        s.appendChild(zeile("Zwischensumme", text(a.zwischensumme)));
        s.appendChild(zeile("Rabatt " + text(a.rabatt.prozent) + " %", "−" + text(a.rabatt.betrag), "mhsys-ag__summe--rabatt"));
      }
      if (a.versand && a.versand.betrag) s.appendChild(zeile(text(a.versand.titel) || "Versand", text(a.versand.betrag)));
      s.appendChild(zeile("Gesamt (inkl. MwSt.)", text(a.gesamt), "mhsys-ag__summe--gesamt"));
    }

    var g = wurzel.querySelector("[data-ag-gueltig]");
    g.textContent = a.gueltig ? "Das Angebot ist freibleibend und gilt bis zum " + text(a.gueltig) + "." : "";
    g.hidden = !a.gueltig;

    var r = a.rechte || {};
    wurzel.querySelector("[data-ag-annehmen]").hidden = !r.zusage;
    var grund = wurzel.querySelector("[data-ag-grund]");
    grund.textContent = !r.zusage && r.grund ? text(r.grund) : "";
    grund.hidden = !grund.textContent;
    wurzel.querySelector("[data-ag-nachricht]").hidden = !r.nachricht;

    var dl = wurzel.querySelector("[data-ag-adressen]");
    dl.textContent = "";
    var ad = a.adressen || {};
    [["Rechnung", ad.rechnung], ["Lieferung", ad.liefer]].forEach(function (x) {
      if (!Array.isArray(x[1]) || !x[1].length) return;
      dl.appendChild(el("dt", "", x[0]));
      var dd = el("dd");
      x[1].forEach(function (z) { dd.appendChild(el("span", "", text(z))); });
      dl.appendChild(dd);
    });
    wurzel.querySelector("[data-ag-adressen-karte]").hidden = !dl.children.length;

    zustand("ansicht");
  }

  function laden(token, danach) {
    zustand("laden");
    return senden("ansicht", { token: token }).then(function (a) {
      if (a.ok) { zeichnen(a); if (danach) danach(); return; }
      if (a.fehler === "token") { merken(""); hinweis(text(a.meldung) || OHNE_ZUGANG); return; }
      if (a.fehler === "grenze") { hinweis(text(a.meldung) || "Bitte versuch es in ein paar Minuten noch einmal."); return; }
      zustand("fehler");
    }).catch(function () { zustand("fehler"); });
  }

  function start() {
    var code = window.mhsysBsCode;
    window.mhsysBsCode = "";
    if (code) {
      zustand("laden");
      senden("code", { code: code }).then(function (a) {
        if (a.ok && a.token) { merken(a.token); laden(a.token); return; }
        hinweis(text(a.meldung) || OHNE_ZUGANG);
      }).catch(function () { zustand("fehler"); });
      return;
    }
    var token = lesen();
    if (token) { laden(token); return; }
    hinweis(OHNE_ZUGANG);
  }

  /* ---- Annehmen ---- */
  var annehmenKnopf = wurzel.querySelector("[data-ag-annehmen-knopf]");
  annehmenKnopf.addEventListener("click", function () {
    if (annehmenKnopf.disabled) return;
    if (!annehmenSchluessel) annehmenSchluessel = schluessel(); // derselbe fuer jeden Versuch - ein Doppelklick nimmt einmal an
    annehmenKnopf.disabled = true;
    meldung("annehmen", "");
    stempeln({ token: lesen(), schluessel: annehmenSchluessel, website: "" }).then(function (r) { return senden("annehmen", r); }).then(function (a) {
      annehmenKnopf.disabled = false;
      if (a.ok) {
        // Stand neu holen (Zusage ist danach nicht mehr moeglich), dann den Dank oben zeigen
        var satz = text(a.meldung) || "Danke – wir haben deine Zusage. Wir legen den Auftrag an und melden uns mit dem Liefertermin.";
        laden(lesen(), function () { erfolg(satz); });
        return;
      }
      if (a.fehler === "token") { merken(""); hinweis(text(a.meldung) || OHNE_ZUGANG); return; }
      meldung("annehmen", text(a.meldung) || "Das hat leider nicht geklappt. Bitte versuch es noch einmal.");
    }).catch(function () {
      annehmenKnopf.disabled = false;
      meldung("annehmen", "Das hat leider nicht geklappt. Bitte versuch es noch einmal.");
    });
  });

  /* ---- Aenderungswuensche (mit Dateien, 3.48 G-T / Enna 5e9b96e) ----
   * Ein vorgang (32 hex) je Nachricht: jede Datei geht vorher einzeln an teil=datei (multipart token, vorgang, datei)
   * und kommt als Kennung mit der Nachricht. Text ODER Datei genuegt. Nach dem Erfolg sind die Kennungen verbraucht:
   * neuer vorgang, leere Liste. Bei einem Fehler bleibt beides liegen - nochmal schicken geht mit denselben Kennungen. */
  var nf = wurzel.querySelector("[data-ag-nachricht-formular]");
  var nk = wurzel.querySelector("[data-ag-nachricht-knopf]");
  var DATEIEN_MAX = 10, DATEI_BYTES = 10 * 1024 * 1024;
  var DATEI_FEHLER = { gross: "ist zu groß.", typ: "hat ein Format, das wir nicht annehmen können.", anzahl: "passt nicht mehr dazu – es sind höchstens 10 Dateien möglich.", grenze: "konnte gerade nicht hochgeladen werden – bitte versuch es später noch einmal.", nicht_mehr: "kann zu diesem Angebot nicht mehr angehängt werden." };
  var vorgang = schluessel();
  var dateien = [];
  var hochladen = 0;
  var dateiFeld = wurzel.querySelector("[data-ag-datei-feld]");
  var dateiListe = wurzel.querySelector("[data-ag-dateien]");
  function dateiMeldung(s) { var m = wurzel.querySelector("[data-ag-datei-meldung]"); m.textContent = s || ""; m.hidden = !s; }
  function groesse(b) { return b >= 1048576 ? (b / 1048576).toFixed(1).replace(".", ",") + " MB" : Math.max(1, Math.round(b / 1024)) + " KB"; }
  function dateienZeichnen() {
    dateiListe.textContent = "";
    dateien.forEach(function (d) {
      var li = el("li", "mhsys-ag__datei");
      li.appendChild(el("span", "mhsys-ag__datei-name", d.name));
      li.appendChild(el("span", "mhsys-ag__datei-groesse", d.groesse ? groesse(d.groesse) : ""));
      var weg = el("button", "mhsys-ag__textknopf", "Entfernen");
      weg.type = "button";
      weg.setAttribute("aria-label", "Datei " + d.name + " entfernen");
      weg.addEventListener("click", function () {
        weg.disabled = true;
        senden("datei_weg", { token: lesen(), vorgang: vorgang, kennung: d.kennung }).then(function (a) {
          if (!a.ok) { weg.disabled = false; dateiMeldung(text(a.meldung) || "Die Datei ließ sich gerade nicht entfernen – probier es noch einmal."); return; }
          dateien = dateien.filter(function (x) { return x.kennung !== d.kennung; });
          dateienZeichnen();
        }).catch(function () { weg.disabled = false; });
      });
      li.appendChild(weg);
      dateiListe.appendChild(li);
    });
    wurzel.querySelector("[data-ag-datei-knopf]").hidden = dateien.length >= DATEIEN_MAX;
  }
  function hochladenEine(datei) {
    return new Promise(function (fertig) {
      var li = el("li", "mhsys-ag__datei");
      li.appendChild(el("span", "mhsys-ag__datei-name", datei.name));
      var balken = el("progress", "mhsys-ag__balken"); balken.max = 100; balken.value = 0;
      balken.setAttribute("aria-label", "Hochladen von " + datei.name);
      li.appendChild(balken);
      dateiListe.appendChild(li);
      var fd = new FormData();
      fd.append("token", lesen());
      fd.append("vorgang", vorgang);
      fd.append("datei", datei, datei.name);
      var x = new XMLHttpRequest();
      x.open("POST", "/apps/kunde?bereich=angebot&teil=datei");
      x.setRequestHeader("Accept", "application/json");
      x.upload.onprogress = function (e) { if (e.lengthComputable) balken.value = Math.round(e.loaded / e.total * 100); };
      x.onload = function () {
        var a = null;
        try { a = JSON.parse(x.responseText); } catch (e) {}
        li.remove();
        if (a && a.ok && a.kennung) { dateien.push({ kennung: text(a.kennung), name: text(a.name) || datei.name, groesse: +a.groesse || datei.size }); dateienZeichnen(); }
        else if (a && a.fehler === "token") { merken(""); hinweis(text(a.meldung) || OHNE_ZUGANG); }
        else dateiMeldung(text(a && a.meldung) || ("„" + datei.name + "“ " + (DATEI_FEHLER[a && a.fehler] || "konnte nicht hochgeladen werden.")));
        fertig();
      };
      x.onerror = function () { li.remove(); dateiMeldung("„" + datei.name + "“ konnte nicht hochgeladen werden – bitte prüf deine Verbindung."); fertig(); };
      // Zeitlimit (Roadmap 7.44): grosszuegig fuer 10 MB am Handy, aber nie ein ewiger Balken
      x.timeout = 120000;
      x.ontimeout = function () { li.remove(); dateiMeldung("„" + datei.name + "“ konnte gerade nicht hochgeladen werden – bitte versuch es in ein paar Minuten noch einmal."); fertig(); };
      x.send(fd);
    });
  }
  dateiFeld.addEventListener("change", function () {
    dateiMeldung("");
    var liste = Array.prototype.slice.call(dateiFeld.files || []);
    dateiFeld.value = "";
    var frei = DATEIEN_MAX - dateien.length, hinweise = [];
    if (liste.length > frei) { hinweise.push("Es sind höchstens " + DATEIEN_MAX + " Dateien möglich."); liste = liste.slice(0, Math.max(0, frei)); }
    liste = liste.filter(function (d) {
      if (!/\.(jpe?g|png|pdf|xlsx?|csv|docx?)$/i.test(d.name)) { hinweise.push("„" + d.name + "“ hat ein Format, das wir nicht annehmen können."); return false; }
      if (d.size > DATEI_BYTES) { hinweise.push("„" + d.name + "“ ist größer als 10 MB."); return false; }
      return true;
    });
    if (hinweise.length) dateiMeldung(hinweise.join(" "));
    hochladen += liste.length;
    liste.reduce(function (p, d) { return p.then(function () { return hochladenEine(d).then(function () { hochladen--; }); }); }, Promise.resolve());
  });

  nf.addEventListener("submit", function (ev) {
    ev.preventDefault();
    var t = text(nf.elements.text.value).trim();
    if (hochladen > 0) { meldung("nachricht", "Bitte warte, bis alle Dateien hochgeladen sind."); return; }
    if (!t && !dateien.length) { meldung("nachricht", "Schreib uns bitte, was anders sein soll – oder häng eine Datei an."); nf.elements.text.focus(); return; }
    nk.disabled = true;
    meldung("nachricht", "");
    stempeln({ token: lesen(), text: t, vorgang: vorgang, dateien: dateien.map(function (d) { return d.kennung; }), website: text(nf.elements.website.value) }).then(function (r) { return senden("nachricht", r); }).then(function (a) {
      nk.disabled = false;
      if (a.ok) {
        nf.reset();
        // Kennungen sind verbraucht: neuer Vorgang fuer die naechste Nachricht
        vorgang = schluessel(); dateien = []; dateienZeichnen(); dateiMeldung("");
        erfolg(text(a.meldung) || "Danke – deine Nachricht ist bei uns. Wir schauen sie uns an und melden uns.");
        return;
      }
      if (a.fehler === "token") { merken(""); hinweis(text(a.meldung) || OHNE_ZUGANG); return; }
      meldung("nachricht", text(a.meldung) || "Das hat leider nicht geklappt. Bitte versuch es noch einmal.");
    }).catch(function () {
      nk.disabled = false;
      meldung("nachricht", "Das hat leider nicht geklappt. Bitte versuch es noch einmal.");
    });
  });

  /* ---- Drucken: Druckansicht dieser Seite (kein PDF, Konzept 3.5) ---- */
  wurzel.querySelector("[data-ag-drucken]").addEventListener("click", function () { window.print(); });

  wurzel.querySelector("[data-ag-nochmal]").addEventListener("click", start);

  start();
})();
